"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeGrayColorsGrouped = exports.themeAccentColorsOrdered = exports.themeAccentColorsGrouped = exports.getMatchingGrayColor = void 0;
const radix_colors_js_1 = require("./helpers/radix-colors.js");
const themeAccentColorsGrouped = [
    { label: 'Regulars', values: [...radix_colors_js_1.radixColorScalesRegular] },
    { label: 'Brights', values: [...radix_colors_js_1.radixColorScalesBright] },
    { label: 'Metals', values: [...radix_colors_js_1.radixColorScalesMetal] },
    { label: 'Gray', values: ['gray'] },
];
exports.themeAccentColorsGrouped = themeAccentColorsGrouped;
const themeAccentColorsOrdered = [
    'gray',
    'gold',
    'bronze',
    'brown',
    'yellow',
    'amber',
    'orange',
    'tomato',
    'red',
    'ruby',
    'crimson',
    'pink',
    'plum',
    'purple',
    'violet',
    'iris',
    'indigo',
    'blue',
    'cyan',
    'teal',
    'jade',
    'green',
    'grass',
    'lime',
    'mint',
    'sky',
];
exports.themeAccentColorsOrdered = themeAccentColorsOrdered;
const themeGrayColorsGrouped = [
    { label: 'Pure', values: [radix_colors_js_1.radixGrayScalePure] },
    { label: 'Desaturated', values: ['auto', ...radix_colors_js_1.radixGrayScalesDesaturated] },
];
exports.themeGrayColorsGrouped = themeGrayColorsGrouped;
function getMatchingGrayColor(accentColor) {
    if (accentColor === 'gray')
        return 'gray';
    return (0, radix_colors_js_1.radixGetMatchingGrayScale)(accentColor);
}
exports.getMatchingGrayColor = getMatchingGrayColor;
//# sourceMappingURL=theme-options.js.map